import React from 'react';
import { ArrowRightIcon } from 'lucide-react';
import { noNeeds, oneSeed } from '../data/content';
export function MissionTransition() {
  return <section aria-labelledby="mission-title" className="bg-cream" data-id="element-204" data-mp="350s8jgt74b05">
      <div className="mx-auto max-w-3xl px-5 py-20 text-center sm:px-8 lg:py-28" data-id="element-205" data-mp="3a2pxmroa2010">
        <h2 id="mission-title" className="font-display text-[40px] leading-[1.05] text-navy sm:text-[56px]" data-id="element-206" data-mp="3f116p06r06i6">
          You Already Know the Mission.
        </h2>
        <p className="mt-5 text-lg text-ink-soft" data-id="element-207" data-mp="2hb66mllfvhog">Jesus already told us to go.</p>
        <p className="mt-8 text-lg text-ink-soft" data-id="element-208" data-mp="2mcdf6mveokw6">The question is:</p>
        <p className="mt-2 font-display text-[28px] leading-tight text-coral sm:text-[34px]" data-id="element-209" data-mp="2ra5h89prlne3">
          Will you keep waiting for the “perfect moment” to start?
        </p>
        <ul className="mx-auto mt-10 max-w-xl space-y-2 text-lg text-ink-soft" data-id="element-210" data-mp="1yn19vy378wz5">
          {noNeeds.map(n => <li key={n} data-id="element-211" data-mp="23kudqkh15ew9">{n}</li>)}
        </ul>
        <p className="mt-8 text-lg font-bold text-navy" data-id="element-212" data-mp="23j9kqzad640i">You can begin with something simple.</p>
        <ol className="mt-6 flex flex-wrap items-center justify-center gap-x-3 gap-y-2" data-id="element-213" data-mp="3ktidmyqlp78f">
          {oneSeed.map((s, i) => <li key={s} className="flex items-center gap-3" data-id="element-214" data-mp="3b1mbncle8wyx" data-mpi={i}>
              {i > 0 && <ArrowRightIcon className="h-4 w-4 text-gold" aria-hidden="true" data-id="element-215" data-mp="3azhzk7dccrnk" />}
              <span className={`font-display text-2xl sm:text-3xl ${i === oneSeed.length - 1 ? 'text-leaf-deep' : 'text-navy'}`} data-id="element-216" data-mp="3700uvg5qnyjg">{s}</span>
            </li>)}
        </ol>
        <p className="mt-4 font-display text-2xl italic text-ink-soft" data-id="element-217" data-mp="2x1bnihbgxwhg">And then another.</p>
      </div>
    </section>;
}